import { render, staticRenderFns } from "./CreateAndEditLabelTemplate.vue?vue&type=template&id=2f62ebee&scoped=true"
import script from "./CreateAndEditLabelTemplate.vue?vue&type=script&lang=js"
export * from "./CreateAndEditLabelTemplate.vue?vue&type=script&lang=js"
import style0 from "./CreateAndEditLabelTemplate.vue?vue&type=style&index=0&id=2f62ebee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f62ebee",
  null
  
)

export default component.exports